module.exports = __webpack_public_path__ + "static/media/logo_stepforma.b9bc99c9.svg";